module.exports = __webpack_public_path__ + "img/paris8.1397204a.png";